export default "__VITE_ASSET__DOH_5H8u__"